import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/app/(public)/[sport]/teams/[team]/[year]/header.tsx");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/app/(public)/[sport]/teams/[team]/[year]/team-profile.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/layout/subnav.tsx");
